import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useRealtimeSubscription } from "./use-realtime";

export const useNotificationCounts = () => {
  useRealtimeSubscription("notification_counts", "notification-counts");

  const { data: counts } = useQuery({
    queryKey: ["notification-counts"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return {};

      const { data, error } = await supabase
        .from("notification_counts")
        .select("*")
        .eq("user_id", user.id);

      if (error) throw error;

      // Convert array to object with page_type as key
      const countsObj: Record<string, number> = {};
      data?.forEach((item: any) => {
        countsObj[item.page_type] = item.count;
      });

      return countsObj;
    },
  });

  const resetCount = async (pageType: string) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.rpc("reset_notification_count", {
      p_user_id: user.id,
      p_page_type: pageType,
    });
  };

  return {
    counts: counts || {},
    resetCount,
  };
};
